import CustomLoader from "@/components/CustomLoader/customLoader.component";
import { ROUTE_LOGIN_OUT } from "@/constants/routes.constants";
import AppProvider from "@/services/AppContext/appProvider";
import {
  getTokensLocalStorage,
  isTokenAboutToExpire,
  isTokenExpired,
  requestAndSetTokens,
} from "@/utils/tokenHandler.util";
import React, { useLayoutEffect, useState } from "react";
import { Navigate, Outlet } from "react-router";

export const ProtectedRoute: React.FC = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isCheckComplete, setIsCheckComplete] = useState(false);

  async function checkUserTokens() {
    // Get tokens from local storage
    const { refreshToken, authToken } = await getTokensLocalStorage();
    // if auth-token exists and is about to expire, requestAndSetTokens
    if (refreshToken && authToken && isTokenAboutToExpire(authToken)) {
      await requestAndSetTokens({ refreshToken: refreshToken });
      // console.log("refreshed tokens!!!!");
    }

    // If the refresh token is expired or invalid, then log the user out
    if (
      !refreshToken ||
      !authToken ||
      refreshToken === "undefined" ||
      isTokenExpired(refreshToken)
    ) {
      setIsLoggedIn(false);
    } else {
      setIsLoggedIn(true);
      isTokenExpired(authToken);
    }

    // checkUserTokens has completed
    setIsCheckComplete(true);
  }

  useLayoutEffect(() => {
    // check if user is valid in every 5 seconds
    checkUserTokens();
    const interval = setInterval(() => {
      checkUserTokens();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return !isCheckComplete ? (
    // If the check is not complete, show a loading spinner
    <div className="container m-auto">
      <CustomLoader />
    </div>
  ) : isLoggedIn ? (
    <AppProvider>
      <Outlet />
    </AppProvider>
  ) : (
    <Navigate to={ROUTE_LOGIN_OUT} />
  );
};

export default ProtectedRoute;
